module.exports = __webpack_public_path__ + "static/media/welcometitle.eb2a36ce.png";